<template>
  <nav
    id="nav"
    class="navbar navbar-default"
    aria-label="Top Navigation Bar"
  >
    <div class="container-fluid">
      <div class="logo">
        <div>
          <router-link role="link" 
            aria-label="Link to Home Page" 
            to="/" 
            class="simple-text logo-mini"
            @click.native="redirectHome()">
            <div class="logo-img">
              <img id="logo-lims" :src="logoIcon" alt="">
            </div>
          </router-link>
        </div>
        <div>
          <router-link 
          role="link" 
          to="/" 
          class="simple-text logo-normal"
          @click.native="redirectHome()">
            {{ title }}
          </router-link>
        </div>
      </div>
      <div v-if="token">
        <a
          href="#"
          @click.stop.prevent="goToPersonalData"
          :key="clientLoggedKey + 1"
          ><span
            style="float: left;"
            class="account-logo prefix"
            :key="clientLoggedKey"
          >
            {{ firstName[0].toUpperCase() + lastName[0].toUpperCase() }}
          </span></a
        >
      </div>
      <div class="navbar-header float-right">
        <!--        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">-->
        <!--          <span class="sr-substring">Toggle navigation</span>-->
        <!--          <span class="icon-bar bar1"></span>-->
        <!--          <span class="icon-bar bar2"></span>-->
        <!--          <span class="icon-bar bar3"></span>-->
        <!--        </button>-->
        <language-button v-if="!token" style="float: left;"></language-button>

        <router-link to="/" class="navbar-brand brand-padding">
          <img
            alt="logo"
            title="logo"
            class="client-logo"
            v-if="checkIfLogoIsBase64()"
            v-bind:src="'data:image/jpeg;base64,' + logo"
          />
          <img v-else alt="logo" title="logo" class="client-logo" :src="logo" />
        </router-link>
      </div>
      <div class="collapse navbar-collapse"></div>
    </div>
  </nav>
</template>

<script>
  import LanguageButton from '../Views/LanguageButton'
  export default {
    data () {
      return {
        clientLoggedKey: 1,
        firstName: localStorage.getItem('firstName'),
        lastName: localStorage.getItem('lastName'),
        token: localStorage.getItem('token'),
        activeNotifications: false,
        title: 'Patient Portal',
        logoIcon: 'static/img/logo.png'
      }
    },
    computed: {
      logo () {
        return this.$store.state.logo
      }
    },
    components: {
      LanguageButton
    },
    methods: {
      redirectHome () {
        window.location.href = window.origin + '/#/'
        if (!this.token) {
          window.location.reload()
        }
      },
      goToPersonalData () {
        this.$router.push({path: '/patient/account/data'})
      },
      checkIfLogoIsBase64 () {
        return this.logo.length % 4 === 0 && /^[A-Za-z0-9+/]+[=]{0,3}$/.test(this.logo)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    },
    watch: {
      '$store.state.clientLoggedKey': {
        handler (before, after) {
          this.firstName = localStorage.getItem('firstName')
          this.lastName = localStorage.getItem('lastName')
          this.clientLoggedKey += 1
        },
        deep: true
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import "../../../assets/sass/paper/_variables.scss";
  .account-logo {
    color: $primary-color;
    border: 2px solid $primary-color;
    padding: 8px;
    border-radius: 21px;
    font-weight: bold;
  }

  .prefix {
    margin-top: 17px;
    margin-left: 25px;
  }

  .navbar {
    background-color: white !important;
  }
  .float-right{
    float: right !important;
  }

  .brand-padding{
    margin: 0px !important;
  }

  .client-logo{
    max-width: 200px;
    max-height: 40px;
  }
  .logo {
    position: relative;
    float:left;
    display: flex;
    align-items: center;
    margin-top: 15px;
  }
  .logo::after{
    content:'';
    position: absolute;
    top:5px;
    right:-12px;
    height:80%;
    width:1px;
    background:#cfcfca;
  }
  .logo img{
    width:40px;
    margin-right: 15px;
    margin-left: 10px;
  }
  .logo .simple-text, .off-canvas-sidebar .logo .simple-text {
    padding: 4px 0px;
    display: block;
    font-size: 14px;
    text-align: center;
    font-weight: 600;
    line-height: 34px;
    text-align: left;
    white-space: nowrap;
    color:#000000;
  }

  @media screen and (max-width: 991px) {
    .logo{
      display: none;
    }
    .brand-padding{
      margin: 12px !important;
    }
    .prefix {
      margin-top: 4px;
      margin-left: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue